import React, { FC, useReducer } from 'react';

import { SearchFilterProvider } from 'providers';
import {
  initialSearchESState,
  SearchEveryoneSocialContext,
  searchEveryoneSocialReducer,
} from '../SearchESContext';
import { FilterBar } from '../components';
import SearchResults from './SearchResults';

const Search: FC = () => {
  const [state, dispatch] = useReducer(searchEveryoneSocialReducer, initialSearchESState);

  return (
    <SearchEveryoneSocialContext.Provider value={{ state, dispatch }}>
      <SearchFilterProvider>
        <FilterBar />
        <SearchResults />
      </SearchFilterProvider>
    </SearchEveryoneSocialContext.Provider>
  );
};

export default Search;
